import React, { useEffect } from "react";
import useReducer from "../../hooks/useReducer";

import Loading from "../overightMui/Loading";
import zuttorideReducer from "../reducer/zuttorideReducer";
import { useStyles } from "../styles/useStyles";
import { getParamUrlByKey } from "../utils";
import Introduce from "./introduce";
import Step_1 from "./step_1";
import Step_2 from "./step_2";
import Step_3 from "./step_3";
import Snackbar from "../overightMui/Snacbar";

const initialState = {
  errors: {},
  configs: {},
  resultBrandsOnSearch: [],
  resultProductLinesOnSearch: [],
  ProductLines: [],
  loading: false,
  loadingPrice: false,
  currentStep: 0,
  openSnackbar: { open: false, message: "", type: "" },
  dataInsu: {},
  vehicleInfo: {},
  insuranceInfo: {},
  dialogBill: {},
  dialogPackage: {},
  dialogSuccess: {},
  percentOfCarPrice: { percent: 0 },
  snackbars: {},
  haveLicense: "license",
  haveBill: "",
  fessTotal: 0,
  redeemCode: {},
  cam_ket: {},
  orders: {},
  commission: {},
  balance: 0,
  foundPackage: {},
  validProductLine: false
};

const renderPage = (currentStep, { state, dispatch, platform }) => {
  switch (currentStep) {
    case 0:
      return <Introduce {...{ state, dispatch, platform }} />;
    case 1:
      return <Step_1 {...{ state, dispatch, platform }} />;
    case 2:
      return <Step_2 {...{ state, dispatch, platform }} />;
    case 3:
      return <Step_3 {...{ state, dispatch, platform }} />;
    default:
      break;
  }
};

export default function MasterRider() {
  const classes = useStyles();

  const platform = getParamUrlByKey("platform");
  const reward = getParamUrlByKey("reward") || null;

  const [state, dispatch] = useReducer({
    reducer: zuttorideReducer,
    name: "zuttorideReducer",
    initialState,
    platform,
    reward,
  });

  useEffect(() => {
    dispatch("initial");
  }, []);

  const { loading, currentStep, snackbars } = state;
  return (
    <div style={{ height: "100%", background: "#F3F3F3" }}>
      <div className={classes.container}>
        {renderPage(currentStep, { state, dispatch, platform })}
      </div>
      <Loading loading={loading} />
      <Snackbar
        open={snackbars.open}
        type={snackbars.type}
        message={snackbars.message}
        onClose={() => dispatch("closeSnackbar")}
      />
    </div>
  );
}
